import DefaultWidgetTemplate from '../DefaultWidgetTemplate';

const NewsletterManagerDefaultWidget = (props) => (
  <DefaultWidgetTemplate
    module={props.module}
    route="user_module_newsletterManager_home"
  />
);

export default NewsletterManagerDefaultWidget;
